import { Outlet } from 'react-router';
import { AccessDenied } from '../../_pages/AccessDenied';
import { useConfigValuesState } from '../../hooks/useConfigValue';

export const AdminRoute = ({ children }: { children: React.ReactNode }) => {
    const {
        initialData: {
            aggregatedUser: { originalUser, delegatedUsers },
        },
    } = useConfigValuesState();

    const hasAccess: boolean = originalUser.isAdmin || originalUser.permissions?.user || originalUser.permissions?.delegates || delegatedUsers.length > 0;

    if (!hasAccess) {
        return <AccessDenied />;
    }

    return children ? <>{children}</> : <Outlet />;
};
